import { createFileRoute } from '@tanstack/react-router';
import { EmissionFactorsClient } from '@/features/fuel/EmissionFactorsClient';

export const Route = createFileRoute('/_shell/fuel/emission-factors')({
  component: EmissionFactorsClient,
});
